import cn from 'classnames';
import type { FunctionComponent, SVGProps } from 'react';
import styles from './icon-wrapper.module.css';

export type IconSize = 'extra-extra-small' | 'extra-small' | 'large' | 'medium-small' | 'middle' | 'small';

type IconColor = 'error' | 'info' | 'placeholder' | 'primary' | 'secondary' | 'success' | 'text' | 'warning';

type P = {
  backgroundColor?: 'white';
  color?: IconColor;
  // TODO: we have round element component, do we need shape here?
  shape?: 'circle';
  size?: IconSize;
  spanClassName?: string;
  spin?: boolean;
} & SvgWrapperProperties;

type SvgWrapperProperties = SVGProps<SVGSVGElement>;

const withAntIconWrapper = (SvgComponent: FunctionComponent<SvgWrapperProperties>) =>
  function ({ backgroundColor, color, rotate, shape, size, spanClassName, spin, ...props }: P) {
    return (
      <span
        className={cn(spanClassName, 'anticon', {
          [styles.spin ?? '']: spin,
          [styles['background-white'] ?? '']: backgroundColor === 'white',
          [styles['color-error'] ?? '']: color === 'error',
          [styles['color-info'] ?? '']: color === 'info',
          [styles['color-placeholder'] ?? '']: color === 'placeholder',
          [styles['color-primary'] ?? '']: color === 'primary',
          [styles['color-secondary'] ?? '']: color === 'secondary',
          [styles['color-success'] ?? '']: color === 'success',
          [styles['color-text'] ?? '']: color === 'text',
          [styles['color-warning'] ?? '']: color === 'warning',
          [styles['shape-circle'] ?? '']: shape === 'circle',
          [styles['size-extra-extra-small'] ?? '']: size === 'extra-extra-small',
          [styles['size-extra-small'] ?? '']: size === 'extra-small',
          [styles['size-large'] ?? '']: size === 'large',
          [styles['size-medium-small'] ?? '']: size === 'medium-small',
          [styles['size-middle'] ?? '']: size === 'middle',
          [styles['size-small'] ?? '']: size === 'small',
        })}
      >
        <SvgComponent style={{ transform: rotate ? `rotate(${rotate}deg)` : undefined }} {...props} />
      </span>
    );
  };

export default withAntIconWrapper;
